/**
 * Owner: Masa Bayu
 * File: MarketplaceFooter.tsx
 * Date:Time: 2026-10-17 06:18
 * Description: Footer navy — tiga item kepercayaan + jenama (anchor sasaran Tentang Kami).
 *   Teks mengikut locale.
 */

import type { ReactElement } from 'react';
import { QX_TAGLINE } from '../../brand/brand-assets';
import { LandingIcon } from './landing/LandingIcons';
import type { MarketplaceLabels } from './marketplace-locale';

export interface MarketplaceFooterProps {
  readonly t: MarketplaceLabels;
}

export function MarketplaceFooter({ t }: MarketplaceFooterProps): ReactElement {
  return (
    <footer className="hmk__footer" id="tentang-kami" aria-label={t.footer.ariaLabel}>
      <div className="hmk__footer-inner">
        {t.footer.trust.map((item) => (
          <div key={item.title} className="hmk__trust">
            <span className="hmk__trust-icon" aria-hidden="true">
              <LandingIcon name={item.icon} size={20} />
            </span>
            <span>
              <strong>{item.title}</strong>
              <small>{item.sub}</small>
            </span>
          </div>
        ))}
        <div className="hmk__footer-brand">
          <img className="hmk__brand-mark" src="/brand/qx.png" alt="" />
          <span className="hmk__brand-text">
            <strong>{QX_TAGLINE.top}</strong>
            <small>{QX_TAGLINE.bottom}</small>
          </span>
        </div>
      </div>
    </footer>
  );
}
